import { EntityType } from 'const';
import * as Models from 'models';
import { getValue } from 'utils/getter';

export function isGroupLayoutDocument(entity: Models.CombinedDocument): entity is Models.GroupLayoutDocument;
export function isGroupLayoutDocument(entity: Models.CombinedDocumentMap): entity is Models.GroupLayoutDocumentMap;
export function isGroupLayoutDocument(entity): boolean {
  return getValue(entity, 'entityType') === EntityType.GROUP_LAYOUT;
}
